module.exports = __webpack_public_path__ + "static/sf-partner-bearingpoint-6e4bb2322aaaf2edae3a65022f6e7f5e.png";